/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

(function() {
  // Fix: Judge.me star ratings load asynchronously and can make a product
  // card taller than it was when a Flickity carousel (e.g. the homepage
  // "Featured products" sliders) first measured its slide heights. When
  // that happens, the extra height (our "Sale Price" markdown line included)
  // gets visually clipped by Flickity's fixed-height, overflow:hidden
  // viewport. Flickity already listens for window "resize" and re-measures
  // itself when it fires, so we just need to fire one after review badges
  // show up.

  var resizeTimer;
  function triggerResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      window.dispatchEvent(new Event('resize'));
    }, 150);
  }

  function isReviewBadge(node) {
    return node.nodeType === 1 && (
      (node.classList && node.classList.contains('jdgm-prev-badge')) ||
      (node.querySelector && node.querySelector('.jdgm-prev-badge'))
    );
  }

  function watchForReviewBadges() {
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('jdgm-prev-badge')) {
          triggerResize();
          return;
        }

        if (m.type === 'childList' && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            if (isReviewBadge(m.addedNodes[j])) {
              triggerResize();
              return;
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForReviewBadges);
  } else {
    watchForReviewBadges();
  }

  // Safety net in case badges appear without a mutation we catch above.
  window.addEventListener('load', function() {
    setTimeout(triggerResize, 1500);
    setTimeout(triggerResize, 3500);
  });
})();

(function() {
  // Move the Judge.me star-rating badge so it appears below the "Sale
  // Price" markdown-price line on product grid cards (collection grids,
  // homepage carousels, etc.), instead of to the left of the regular
  // price, so everything lines up consistently across cards.
  //
  // Judge.me injects its badge asynchronously as a ".jdgm-prev-badge"
  // wrapped in a ".emvs-review-wrapper" div, placed inside
  // ".product__grid__price". We relocate that wrapper to just after the
  // ".product__grid__markdown-price" div (or after ".product__grid__price"
  // itself when there's no markdown price) within the same
  // ".product__grid__info" block.

  function findReviewWrapper(node) {
    if (!node || node.nodeType !== 1) return null;
    if (node.classList && node.classList.contains('emvs-review-wrapper')) return node;
    if (node.closest) {
      var closest = node.closest('.emvs-review-wrapper');
      if (closest) return closest;
    }
    return node.querySelector ? node.querySelector('.emvs-review-wrapper') : null;
  }

  function repositionReviewWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.repositioned === 'true') return;

    var infoBlock = wrapper.closest('.product__grid__info');
    if (!infoBlock) return;

    var target = infoBlock.querySelector('.product__grid__markdown-price') ||
      infoBlock.querySelector('.product__grid__price');
    if (!target) return;

    target.insertAdjacentElement('afterend', wrapper);
    wrapper.dataset.repositioned = 'true';
  }

  function repositionAllExisting() {
    document.querySelectorAll('.emvs-review-wrapper').forEach(repositionReviewWrapper);
  }

  function watchForReviewWrapperMoves() {
    repositionAllExisting();

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'attributes' && m.target.classList && m.target.classList.contains('jdgm-prev-badge')) {
          repositionReviewWrapper(findReviewWrapper(m.target));
          continue;
        }

        if (m.type === 'childList' && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var wrapper = findReviewWrapper(m.addedNodes[j]);
            if (wrapper) {
              repositionReviewWrapper(wrapper);
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForReviewWrapperMoves);
  } else {
    watchForReviewWrapperMoves();
  }

  // Safety net in case a wrapper appears without a mutation we catch above.
  window.addEventListener('load', function() {
    setTimeout(repositionAllExisting, 1500);
    setTimeout(repositionAllExisting, 3500);
  });
})();
